import { IAddress } from '@faire/web-api--source/indigofair/data/IAddress';
import { IDocument } from '@faire/web-api--source/indigofair/data/IDocument';
import { IFaireMoney } from '@faire/web-api--source/indigofair/data/IFaireMoney';
import { IRetailer } from '@faire/web-api--source/indigofair/data/IRetailer';
import { IRetailerGrantsApplication } from '@faire/web-api--source/indigofair/data/IRetailerGrantsApplication';
import { IRetailerLaunchWithFaire } from '@faire/web-api--source/indigofair/data/IRetailerLaunchWithFaire';

export namespace IRetailerLaunchWithFaireApplication {
  export enum State {
    STATE_UNKNOWN = 'STATE_UNKNOWN',
    SUBMITTED = 'SUBMITTED',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
  }

  export enum LeaseSigned {
    LEASE_SIGNED_UNKNOWN = 'LEASE_SIGNED_UNKNOWN',
    YES = 'YES',
    NO = 'NO',
    OWNED = 'OWNED',
  }

  export enum LeaseLength {
    LEASE_LENGTH_UNKNOWN = 'LEASE_LENGTH_UNKNOWN',
    ZERO_SIX_MONTHS = 'ZERO_SIX_MONTHS',
    SIX_TWELVE_MONTHS = 'SIX_TWELVE_MONTHS',
    ONE_TWO_YEARS = 'ONE_TWO_YEARS',
    TWO_FOUR_YEARS = 'TWO_FOUR_YEARS',
    OVER_FOUR_YEARS = 'OVER_FOUR_YEARS',
  }

  export enum FundingAmount {
    FUNDING_AMOUNT_UNKNOWN = 'FUNDING_AMOUNT_UNKNOWN',
    UNDER_10K = 'UNDER_10K',
    RANGE_10K_20K = 'RANGE_10K_20K',
    RANGE_20K_50K = 'RANGE_20K_50K',
    RANGE_50K_100K = 'RANGE_50K_100K',
    RANGE_100K_200K = 'RANGE_100K_200K',
    OVER_200K = 'OVER_200K',
    NONE = 'NONE',
  }

  export enum CreditLimit {
    CREDIT_LIMIT_UNKNOWN = 'CREDIT_LIMIT_UNKNOWN',
    UNDER_5K = 'UNDER_5K',
    RANGE_5K_10K = 'RANGE_5K_10K',
    RANGE_10K_15K = 'RANGE_10K_15K',
    RANGE_15K_25K = 'RANGE_15K_25K',
    OVER_25K = 'OVER_25K',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
  }

  export enum PreferredTermsAmount {
    PREFERRED_TERMS_AMOUNT_UNKNOWN = 'PREFERRED_TERMS_AMOUNT_UNKNOWN',
    TERMS_UNDER_5K = 'TERMS_UNDER_5K',
    TERMS_RANGE_5K_10K = 'TERMS_RANGE_5K_10K',
    TERMS_RANGE_10K_15K = 'TERMS_RANGE_10K_15K',
    TERMS_RANGE_15K_20K = 'TERMS_RANGE_15K_20K',
    TERMS_OVER_20K = 'TERMS_OVER_20K',
    TERMS_RANGE_5K_7K = 'TERMS_RANGE_5K_7K',
    TERMS_UNDER_2500 = 'TERMS_UNDER_2500',
    TERMS_RANGE_2500_5K = 'TERMS_RANGE_2500_5K',
    TERMS_RANGE_5K_7500 = 'TERMS_RANGE_5K_7500',
    TERMS_RANGE_7500_10K = 'TERMS_RANGE_7500_10K',
    TERMS_OVER_10K = 'TERMS_OVER_10K',
  }

  export enum MarketingAmount {
    MARKETING_AMOUNT_UNKNOWN = 'MARKETING_AMOUNT_UNKNOWN',
    MARKETING_UNDER_500 = 'MARKETING_UNDER_500',
    MARKETING_RANGE_500_1K = 'MARKETING_RANGE_500_1K',
    MARKETING_RANGE_1K_2K = 'MARKETING_RANGE_1K_2K',
    MARKETING_RANGE_2K_3K = 'MARKETING_RANGE_2K_3K',
    MARKETING_OVER_3K = 'MARKETING_OVER_3K',
  }

  export enum StoreHoursCommitment {
    STORE_HOURS_COMMITMENT_UNKNOWN = 'STORE_HOURS_COMMITMENT_UNKNOWN',
    TIME_RANGE_0H_8H = 'TIME_RANGE_0H_8H',
    TIME_RANGE_8H_24H = 'TIME_RANGE_8H_24H',
    TIME_RANGE_24H_40H = 'TIME_RANGE_24H_40H',
    TIME_OVER_40H = 'TIME_OVER_40H',
  }

  export enum PopUpLease {
    POP_UP_LEASE_UNKNOWN = 'POP_UP_LEASE_UNKNOWN',
    YES_LEASE = 'YES_LEASE',
    NO_LEASE = 'NO_LEASE',
    LEASE_NOT_REQUIRED = 'LEASE_NOT_REQUIRED',
  }

  export enum PopUpMonthsOpen {
    POP_UP_MONTHS_OPEN_UNKNOWN = 'POP_UP_MONTHS_OPEN_UNKNOWN',
    POPUP_MONTHS_RANGE_0_1 = 'POPUP_MONTHS_RANGE_0_1',
    POPUP_MONTHS_RANGE_1_3 = 'POPUP_MONTHS_RANGE_1_3',
    POPUP_MONTHS_RANGE_3_6 = 'POPUP_MONTHS_RANGE_3_6',
    POPUP_MONTHS_RANGE_6_12 = 'POPUP_MONTHS_RANGE_6_12',
    POPUP_MONTHS_OVER_12 = 'POPUP_MONTHS_OVER_12',
  }

  export enum PopUpHoursOpen {
    POP_UP_HOURS_OPEN_UNKNOWN = 'POP_UP_HOURS_OPEN_UNKNOWN',
    POPUP_HOURS_UNDER_2 = 'POPUP_HOURS_UNDER_2',
    POPUP_HOURS_RANGE_2_4 = 'POPUP_HOURS_RANGE_2_4',
    POPUP_HOURS_RANGE_4_8 = 'POPUP_HOURS_RANGE_4_8',
    POPUP_HOURS_RANGE_8_12 = 'POPUP_HOURS_RANGE_8_12',
    POPUP_HOURS_OVER_12 = 'POPUP_HOURS_OVER_12',
  }

  export enum HasStoreWebsite {
    HAS_STORE_WEBSITE_UNKNOWN = 'HAS_STORE_WEBSITE_UNKNOWN',
    HAS_WEBSITE = 'HAS_WEBSITE',
    NO_WEBSITE = 'NO_WEBSITE',
    NOT_STARTED = 'NOT_STARTED',
    COMING_SOON = 'COMING_SOON',
  }

  export enum FicoScore {
    FICO_SCORE_UNKNOWN = 'FICO_SCORE_UNKNOWN',
    FICO_SCORE_NONE = 'FICO_SCORE_NONE',
    UNDER_500 = 'UNDER_500',
    BETWEEN_500_TO_600 = 'BETWEEN_500_TO_600',
    BETWEEN_600_TO_650 = 'BETWEEN_600_TO_650',
    BETWEEN_650_TO_700 = 'BETWEEN_650_TO_700',
    BETWEEN_700_TO_750 = 'BETWEEN_700_TO_750',
    OVER_750 = 'OVER_750',
  }

  /**
   * @deprecated
   */
  export enum ApplicationType {
    /**
     * Use indigofair.data.RetailerLaunchWithFaire.ApplicationType instead.
     */
    APPLICATION_TYPE_UNKNOWN = 'APPLICATION_TYPE_UNKNOWN',
    SOFT_CREDIT_CHECK = 'SOFT_CREDIT_CHECK',
    PRE_QUALIFIED = 'PRE_QUALIFIED',
  }

  /**
   * Return an instance of IRetailerLaunchWithFaireApplication with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IRetailerLaunchWithFaireApplication>
  ): IRetailerLaunchWithFaireApplication =>
    ({
      documents: [],
      online_website_proof_documents: [],
      business_tax_documents: [],
      lease_agreement_documents: [],
      pop_up_proof_documents: [],
      ...(partial ?? {}),
    }) as IRetailerLaunchWithFaireApplication;
}

export interface IRetailerLaunchWithFaireApplication {
  state: keyof typeof IRetailerLaunchWithFaireApplication.State | undefined;
  full_name: string | undefined;
  residential_address: IAddress | undefined;
  store_name: string | undefined;
  opening_range: string | undefined;
  lease_signed:
    | keyof typeof IRetailerLaunchWithFaireApplication.LeaseSigned
    | undefined;
  lease_length:
    | keyof typeof IRetailerLaunchWithFaireApplication.LeaseLength
    | undefined;
  monthly_rent: IFaireMoney | undefined;
  store_address: IAddress | undefined;
  store_square_footage: number | undefined;
  store_square_meterage: number | undefined;
  /**
   * @deprecated
   */
  funding_amount:
    | keyof typeof IRetailerLaunchWithFaireApplication.FundingAmount
    | undefined;
  funding_amount_min: IFaireMoney | undefined;
  funding_amount_max: IFaireMoney | undefined;
  funding_sources: string | undefined;
  /**
   * @deprecated
   */
  credit_card_limit:
    | keyof typeof IRetailerLaunchWithFaireApplication.CreditLimit
    | undefined;
  credit_card_limit_min: IFaireMoney | undefined;
  credit_card_limit_max: IFaireMoney | undefined;
  website_url: string | undefined;
  social_media: string | undefined;
  additional_information: string | undefined;
  documents: Array<IDocument>;
  credit_check_authorized: boolean | undefined;
  residential_address_google_place_id: string | undefined;
  store_address_google_place_id: string | undefined;
  /**
   * @deprecated
   */
  preferred_terms_amount:
    | keyof typeof IRetailerLaunchWithFaireApplication.PreferredTermsAmount
    | undefined;
  preferred_terms_amount_min: IFaireMoney | undefined;
  preferred_terms_amount_max: IFaireMoney | undefined;
  /**
   * @protobufOption (.faire.common.tokenType) = RETAILER
   */
  retailer_token: string | undefined;
  submitted_at: number | undefined;
  /**
   * @deprecated
   */
  marketing_amount:
    | keyof typeof IRetailerLaunchWithFaireApplication.MarketingAmount
    | undefined;
  marketing_amount_min: IFaireMoney | undefined;
  marketing_amount_max: IFaireMoney | undefined;
  store_hours_commitment:
    | keyof typeof IRetailerLaunchWithFaireApplication.StoreHoursCommitment
    | undefined;
  popup_location_events: boolean | undefined;
  popup_location_brick_and_mortar: boolean | undefined;
  popup_locations: string | undefined;
  popup_lease:
    | keyof typeof IRetailerLaunchWithFaireApplication.PopUpLease
    | undefined;
  popup_months_open:
    | keyof typeof IRetailerLaunchWithFaireApplication.PopUpMonthsOpen
    | undefined;
  popup_days_per_week: number | undefined;
  popup_hours_open:
    | keyof typeof IRetailerLaunchWithFaireApplication.PopUpHoursOpen
    | undefined;
  popup_cost: string | undefined;
  best_store_type: keyof typeof IRetailer.BusinessCategory | undefined;
  customer_acquisition_plan: string | undefined;
  online_has_store_website:
    | keyof typeof IRetailerLaunchWithFaireApplication.HasStoreWebsite
    | undefined;
  online_website_proof_documents: Array<IDocument>;
  fico_score:
    | keyof typeof IRetailerLaunchWithFaireApplication.FicoScore
    | undefined;
  planned_selling_medium: string | undefined;
  business_tax_documents: Array<IDocument>;
  lease_agreement_documents: Array<IDocument>;
  pop_up_proof_documents: Array<IDocument>;
  website_url_social_media_combined: string | undefined;
  /**
   * @deprecated
   */
  application_type:
    | keyof typeof IRetailerLaunchWithFaireApplication.ApplicationType
    | undefined;
  application_form_type:
    | keyof typeof IRetailerLaunchWithFaire.ApplicationType
    | undefined;
  retailer_grants_application: IRetailerGrantsApplication | undefined;
  date_of_birth: number | undefined;
  first_name: string | undefined;
  last_name: string | undefined;
}
